module.exports = __webpack_public_path__ + "img/download-tile-bg-desktop_en.1149e53.jpg";